// Textos do Plano de saúde (27/10/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.plano.dadoMinimo': 'Dado mínimo de saúde',
    'dp.plano.titulo': 'Plano de saúde',
    'dp.plano.mesFatura': 'Mês da fatura',
    'dp.plano.vazio': 'Nenhuma fatura carregada ainda. Importe os relatórios de mensalidade e coparticipação da operadora.',
    'dp.plano.explica': 'Uma linha por titular, com a família inteira e os contratos da operadora. Do dependente não há CPF nem procedimento: a coparticipação fica somada no titular.',
    'dp.plano.kpi.titulares': 'Titulares',
    'dp.plano.kpi.beneficiarios': 'Beneficiários',
    'dp.plano.kpi.semFolha': 'Sem matrícula',
    'dp.plano.mensalidade': 'Mensalidade',
    'dp.plano.coparticipacao': 'Coparticipação',
    'dp.plano.col.titular': 'Titular',
    'dp.plano.col.casamento': 'Matrícula',
    'dp.plano.col.beneficiarios': 'Beneficiários',
    'dp.plano.col.beneficiario': 'Beneficiário',
    'dp.plano.col.parentesco': 'Parentesco',
    'dp.plano.col.contrato': 'Contrato',
    'dp.plano.col.cobrado': 'Cobrado',
    'dp.plano.contratoPlano': '{{contrato}}, plano {{plano}}',
    'dp.plano.familia': 'Família',
    'dp.plano.semFolha': 'O titular não casou com a folha pelo CPF. Aponte a filial e a matrícula.',
    'dp.plano.semFolhaCurto': 'Sem matrícula',
    'dp.plano.casamento.cpf': 'Matrícula {{m}}, achada pelo CPF.',
    'dp.plano.casamento.matricula': 'Matrícula {{m}}, achada pela matrícula que a operadora traz.',
    'dp.plano.casamento.confirmado': 'Matrícula {{m}}, confirmada pelo DP.',
    'dp.plano.casamentoCurto.cpf': 'Pelo CPF',
    'dp.plano.casamentoCurto.matricula': 'Pela operadora',
    'dp.plano.casamentoCurto.nome': 'Pelo nome',
    'dp.plano.casamentoCurto.confirmado': 'Confirmada',
    'dp.plano.casamento.nome': 'Matrícula {{m}}, achada pelo nome e pela data de nascimento no quadro do Protheus.',
    'dp.plano.col.operadora': 'Operadora',
    'dp.plano.operadora.todas': 'Todas',
    'dp.plano.operadora.hapvida': 'Hapvida',
    'dp.plano.operadora.unimed': 'Unimed',
    'dp.plano.familiaNaOperadora': 'Família na operadora',
    'dp.plano.importarDe.hapvida': 'Fatura da Hapvida',
    'dp.plano.importarDe.unimed': 'Fatura da Unimed',
    'dp.plano.apontarTitulo': 'Apontar a matrícula do titular',
    'dp.plano.matricula': 'Matrícula',
    'dp.plano.apontar': 'Usar esta matrícula',
    'dp.plano.confirmar': 'Confirmar a matrícula',
    'dp.plano.importarTitulo': 'Importar a fatura da Hapvida',
    'dp.plano.importarExplica': 'Os dois relatórios da mesma fatura, baixados do portal da operadora: a mensalidade e, quando houver, a coparticipação. O procedimento médico é lido e descartado; carregar o mesmo mês de novo atualiza os valores.',
    'dp.plano.arquivoMensalidade': 'Relatório de mensalidade',
    'dp.plano.arquivoCoparticipacao': 'Relatório de coparticipação',
    'dp.plano.carga.valorFatura': 'Valor da fatura',
    'dp.plano.carga.semTitular': 'Procedimentos sem titular',
    'dp.plano.unimed.importarTitulo': 'Importar a fatura da Unimed',
    'dp.plano.unimed.importarExplica': 'Os dois PDFs da operadora, juntos ou um de cada vez: o Demonstrativo de Repasse Faturamento, que é a mensalidade, e o SLIP, que é a utilização e vira a coparticipação. O titular casa com a folha pelo nome e pela data de nascimento no quadro do Protheus. O procedimento médico é lido e descartado.',
    'dp.plano.unimed.arquivoDemonstrativo': 'Demonstrativo de Repasse',
    'dp.plano.unimed.arquivoSlip': 'SLIP da utilização',
    'dp.plano.unimed.competenciaUtilizacao': 'Competência da utilização',
    'dp.plano.unimed.titularesSemFatura': 'Titulares do SLIP fora da fatura',
    'dp.plano.col.filialOperadora': 'Filial e operadora',
  },
  en: {
    'dp.plano.dadoMinimo': 'Minimal health data',
    'dp.plano.titulo': 'Health plan',
    'dp.plano.mesFatura': 'Invoice month',
    'dp.plano.vazio': 'No invoice loaded yet. Import the provider monthly fee and copayment reports.',
    'dp.plano.explica': 'One row per holder, with the whole family and the provider contracts. There is no ID number or procedure for dependents: the copayment is summed on the holder.',
    'dp.plano.kpi.titulares': 'Holders',
    'dp.plano.kpi.beneficiarios': 'Beneficiaries',
    'dp.plano.kpi.semFolha': 'No employee ID',
    'dp.plano.mensalidade': 'Monthly fee',
    'dp.plano.coparticipacao': 'Copayment',
    'dp.plano.col.titular': 'Holder',
    'dp.plano.col.casamento': 'Employee ID',
    'dp.plano.col.beneficiarios': 'Beneficiaries',
    'dp.plano.col.beneficiario': 'Beneficiary',
    'dp.plano.col.parentesco': 'Relationship',
    'dp.plano.col.contrato': 'Contract',
    'dp.plano.col.cobrado': 'Charged',
    'dp.plano.contratoPlano': '{{contrato}}, plan {{plano}}',
    'dp.plano.familia': 'Family',
    'dp.plano.semFolha': 'The holder did not match the payroll by ID number. Point the branch and employee ID.',
    'dp.plano.semFolhaCurto': 'No employee ID',
    'dp.plano.casamento.cpf': 'Employee ID {{m}}, found by ID number.',
    'dp.plano.casamento.matricula': 'Employee ID {{m}}, found by the provider employee ID.',
    'dp.plano.casamento.confirmado': 'Employee ID {{m}}, confirmed by HR.',
    'dp.plano.casamentoCurto.cpf': 'By ID number',
    'dp.plano.casamentoCurto.matricula': 'By provider',
    'dp.plano.casamentoCurto.nome': 'By name',
    'dp.plano.casamentoCurto.confirmado': 'Confirmed',
    'dp.plano.casamento.nome': 'Employee ID {{m}}, found by name and date of birth in the Protheus roster.',
    'dp.plano.col.operadora': 'Provider',
    'dp.plano.operadora.todas': 'All',
    'dp.plano.operadora.hapvida': 'Hapvida',
    'dp.plano.operadora.unimed': 'Unimed',
    'dp.plano.familiaNaOperadora': 'Family at the provider',
    'dp.plano.importarDe.hapvida': 'Hapvida invoice',
    'dp.plano.importarDe.unimed': 'Unimed invoice',
    'dp.plano.apontarTitulo': 'Point the holder employee ID',
    'dp.plano.matricula': 'Employee ID',
    'dp.plano.apontar': 'Use this employee ID',
    'dp.plano.confirmar': 'Confirm the employee ID',
    'dp.plano.importarTitulo': 'Import the Hapvida invoice',
    'dp.plano.importarExplica': 'Both reports of the same invoice, downloaded from the provider portal: the monthly fee and, when there is one, the copayment. The medical procedure is read and discarded; loading the same month again updates the amounts.',
    'dp.plano.arquivoMensalidade': 'Monthly fee report',
    'dp.plano.arquivoCoparticipacao': 'Copayment report',
    'dp.plano.carga.valorFatura': 'Invoice amount',
    'dp.plano.carga.semTitular': 'Procedures without a holder',
    'dp.plano.unimed.importarTitulo': 'Import the Unimed invoice',
    'dp.plano.unimed.importarExplica': 'The two provider PDFs, together or one at a time: the Demonstrativo de Repasse Faturamento, which is the monthly fee, and the SLIP, which is the usage and becomes the copayment. The holder matches the payroll by name and date of birth in the Protheus roster. The medical procedure is read and discarded.',
    'dp.plano.unimed.arquivoDemonstrativo': 'Demonstrativo de Repasse',
    'dp.plano.unimed.arquivoSlip': 'Usage SLIP',
    'dp.plano.unimed.competenciaUtilizacao': 'Usage period',
    'dp.plano.unimed.titularesSemFatura': 'SLIP holders outside the invoice',
    'dp.plano.col.filialOperadora': 'Branch and provider',
  },
  es: {
    'dp.plano.dadoMinimo': 'Dato mínimo de salud',
    'dp.plano.titulo': 'Plan de salud',
    'dp.plano.mesFatura': 'Mes de la factura',
    'dp.plano.vazio': 'Aún no hay factura cargada. Importe los informes de mensualidad y copago de la operadora.',
    'dp.plano.explica': 'Una fila por titular, con toda la familia y los contratos de la operadora. Del dependiente no hay documento ni procedimiento: el copago queda sumado en el titular.',
    'dp.plano.kpi.titulares': 'Titulares',
    'dp.plano.kpi.beneficiarios': 'Beneficiarios',
    'dp.plano.kpi.semFolha': 'Sin matrícula',
    'dp.plano.mensalidade': 'Mensualidad',
    'dp.plano.coparticipacao': 'Copago',
    'dp.plano.col.titular': 'Titular',
    'dp.plano.col.casamento': 'Matrícula',
    'dp.plano.col.beneficiarios': 'Beneficiarios',
    'dp.plano.col.beneficiario': 'Beneficiario',
    'dp.plano.col.parentesco': 'Parentesco',
    'dp.plano.col.contrato': 'Contrato',
    'dp.plano.col.cobrado': 'Cobrado',
    'dp.plano.contratoPlano': '{{contrato}}, plan {{plano}}',
    'dp.plano.familia': 'Familia',
    'dp.plano.semFolha': 'El titular no coincidió con la nómina por el documento. Indique la filial y la matrícula.',
    'dp.plano.semFolhaCurto': 'Sin matrícula',
    'dp.plano.casamento.cpf': 'Matrícula {{m}}, encontrada por el documento.',
    'dp.plano.casamento.matricula': 'Matrícula {{m}}, encontrada por la matrícula de la operadora.',
    'dp.plano.casamento.confirmado': 'Matrícula {{m}}, confirmada por el DP.',
    'dp.plano.casamentoCurto.cpf': 'Por el documento',
    'dp.plano.casamentoCurto.matricula': 'Por la operadora',
    'dp.plano.casamentoCurto.nome': 'Por el nombre',
    'dp.plano.casamentoCurto.confirmado': 'Confirmada',
    'dp.plano.casamento.nome': 'Matrícula {{m}}, encontrada por el nombre y la fecha de nacimiento en el cuadro de Protheus.',
    'dp.plano.col.operadora': 'Operadora',
    'dp.plano.operadora.todas': 'Todas',
    'dp.plano.operadora.hapvida': 'Hapvida',
    'dp.plano.operadora.unimed': 'Unimed',
    'dp.plano.familiaNaOperadora': 'Familia en la operadora',
    'dp.plano.importarDe.hapvida': 'Factura de Hapvida',
    'dp.plano.importarDe.unimed': 'Factura de Unimed',
    'dp.plano.apontarTitulo': 'Indicar la matrícula del titular',
    'dp.plano.matricula': 'Matrícula',
    'dp.plano.apontar': 'Usar esta matrícula',
    'dp.plano.confirmar': 'Confirmar la matrícula',
    'dp.plano.importarTitulo': 'Importar la factura de Hapvida',
    'dp.plano.importarExplica': 'Los dos informes de la misma factura, descargados del portal de la operadora: la mensualidad y, cuando haya, el copago. El procedimiento médico se lee y se descarta; cargar el mismo mes de nuevo actualiza los valores.',
    'dp.plano.arquivoMensalidade': 'Informe de mensualidad',
    'dp.plano.arquivoCoparticipacao': 'Informe de copago',
    'dp.plano.carga.valorFatura': 'Valor de la factura',
    'dp.plano.carga.semTitular': 'Procedimientos sin titular',
    'dp.plano.unimed.importarTitulo': 'Importar la factura de Unimed',
    'dp.plano.unimed.importarExplica': 'Los dos PDF de la operadora, juntos o de a uno: el Demonstrativo de Repasse Faturamento, que es la mensualidad, y el SLIP, que es la utilización y se convierte en el copago. El titular coincide con la nómina por el nombre y la fecha de nacimiento en el cuadro de Protheus. El procedimiento médico se lee y se descarta.',
    'dp.plano.unimed.arquivoDemonstrativo': 'Demonstrativo de Repasse',
    'dp.plano.unimed.arquivoSlip': 'SLIP de utilización',
    'dp.plano.unimed.competenciaUtilizacao': 'Competencia de la utilización',
    'dp.plano.unimed.titularesSemFatura': 'Titulares del SLIP fuera de la factura',
    'dp.plano.col.filialOperadora': 'Sucursal y aseguradora',
  },
}
